import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { Delegate } from './delegateApiTypes';

export const getDelegates = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<Delegate>>(config, `/user-delegate`, 'GET', null, commonHeaders);

export const createDelegate = async (config: LoruleRequestConfig, delegate: Delegate) =>
    callWebUtils(config, `/user-delegate`, 'POST', JSON.stringify(delegate), commonHeaders);

export const updateDelegate = async (config: LoruleRequestConfig, delegate: Delegate) =>
    callWebUtils(
        config,
        `/user-delegate/${delegate.id}`,
        'PUT',
        JSON.stringify(delegate),
        commonHeaders,
    );

export const deleteDelegate = async (config: LoruleRequestConfig, id: number) =>
    callWebUtils(config, `/user-delegate/${id}`, 'DELETE', null, commonHeaders);
